
export const LocalImage = ({ imageReference }) => {
    return (
        <img src={imageReference} alt='Showing shuntconfiguration' width={430} />
    );
}